<template>
    <el-dialog title="编辑地址" :visible.sync="addressPop" width="800px" class="dialog-header-border"
        @close="closePop" @open="openPop"
    >
        <div class="add-address-wrap" v-if="formVisable">
            <el-form
                :model="addressForm"
                :rules="addressFormRules"
                ref="addressForm"
                label-width="100px"
            >
                <el-form-item prop="addressContactName" size="small" label="姓名">
                    <el-input type="text" v-model.trim="addressForm.addressContactName"
                        placeholder="请输入您的姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="addressContactPhone" size="small" label="手机号">
                    <el-input type="text" v-model.trim="addressForm.addressContactPhone"
                        placeholder="请输入您的手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item size="small" label="省市区" required prop="addressArea">
                    <area-picker type="edit" :data.sync="addressForm.addressArea" />
                </el-form-item>
                <el-form-item prop="addressString" size="small" label="详细地址">
                    <el-input type="textarea" v-model.trim="addressForm.addressString"
                        placeholder="请输入详细地址"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="addressIsDefault" label="设为默认">
                    <el-switch v-model="addressForm.addressIsDefault"></el-switch>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelHandle">取消</el-button>
            <el-button type="primary" @click="submitAddAddress">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { validateMobile } from '@/utils/validate.js'
import areaPicker from '@/components/areaPicker.vue'
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        addressId: {
            type: [String, Number],
            required: true
        }
    },
    components: {
        areaPicker
    },
    computed: {
        ...mapGetters(['userId'])
    },
    watch: {
        visible: function(val) {
            this.addressPop = val
        } 
    },
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!validateMobile(value)){
                callback(new Error('手机号格式不正确'))
            } else {
                callback()
            }
        }
        var validAddressArea = (rule, value, callback) => {
            // console.log(value)
            if (!this.addressForm.addressArea.regionCity.region_id) {
                callback(new Error('请选择省市区'))
            } else {
                callback()
            }
        }
        return {
            addressPop: false,
            formVisable: true,
            addressForm: {
                addressArea: {
                    regionProvince: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionCity: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionDistrict: {
                        region_name:  '',
                        region_id: ''
                    }
                },
                addressString: '',
                addressContactName: '',
                addressContactPhone: '',
                addressIsDefault: false
            },
            addressFormRules: {
                addressContactName: [
                    { required: true, message: "请输入姓名", trigger: 'change' }
                ],
                addressContactPhone: [
                    { required: true, validator: validatePhone, trigger: 'change' }
                ],
                addressArea: [
                    { validator: validAddressArea }
                ],
                addressString: [
                    { required: true, message: "请输入详细地址", trigger: 'change' }
                ],
            },
        }
    },
    methods: {
        closePop() {
            this.$emit('update:visible', this.addressPop)
            this.resetForm()
        },
        cancelHandle() {
            this.addressPop = false
        },
        openPop() {
            this.getCurrentAddress()
        },
        resetForm() {
            this.$refs['addressForm'].resetFields()
            this.formVisable = false
            this.$nextTick(() => {
                this.formVisable = true
            })
        },
        getCurrentAddress() {
            request({
                url:api.findUserAddressByAId,
                data: {
                    addressId: this.addressId
                }
            }).then(res => {
                if (res.errorCode == 200) {
                    let item = res.data
                    this.addressForm =  {
                        addressArea: {
                            regionProvince: {
                                region_name: item.region_province_string || '',
                                region_id: item.region_province_id || ''
                            },
                            regionCity: {
                                region_name: item.region_city_string || '',
                                region_id: item.region_city_id || '',
                            },
                            regionDistrict: {
                                region_name: item.region_district_string || '',
                                region_id: item.region_district_id || '',
                            }
                        },
                        addressString: item.address_string,
                        addressContactName: item.address_contact_name,
                        addressContactPhone: item.address_contact_phone,
                        addressIsDefault: item.address_is_default == 'y' ? true : false
                    }
                } else {
                    this.$message.error(res.errorMsg || '网络错误')
                }
            })
        },
        submitAddAddress() {
            this.$refs['addressForm'].validate(valid => {
                if (valid) {
                    // console.log('pass')
                    let addressArea = this.addressForm.addressArea
                    let params = {
                        userId: this.userId,
                        addressId: this.addressId,
                        addressString: this.addressForm.addressString,
                        addressContactName: this.addressForm.addressContactName,
                        addressContactPhone: this.addressForm.addressContactPhone,
                        regionProvinceId: addressArea.regionProvince.region_id,
                        regionProvinceString: addressArea.regionProvince.region_name,
                        regionCityId: addressArea.regionCity.region_id,
                        regionCityString: addressArea.regionCity.region_name,
                        regionDistrictId: addressArea.regionDistrict.region_id,
                        regionDistrictString: addressArea.regionDistrict.region_name,
                        addressIsDefault: this.addressForm.addressIsDefault ? 'y' : 'n'
                    }
                    // console.log(params)

                    request({
                        url: api.updateAddressByAddressId,
                        data: params,
                        loading: true
                    }).then(res => {
                        if(res.errorCode==200){
                            this.$message.success('编辑成功')
                            this.addressPop = false
                            this.$emit('on-success')
                        } else {
                            this.$message.error(res.errorMsg || '网络错误')
                        }
                    })
                }    
            })
        }
    }
}
</script>

<style scoped>
.add-address-wrap {
    width: 700px;
}
</style>